import { render, staticRenderFns } from "./ArticlesGrid.vue?vue&type=template&id=87207e52"
import script from "./ArticlesGrid.vue?vue&type=script&lang=js"
export * from "./ArticlesGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports